import { Accordion } from './Accordion';
import { Button } from './Button';
import { Card } from './Card';
import { Date } from './Date';
import { Dialog } from './Dialog';
import { Form } from './Form';
import { Fraction } from './Fraction';
import { Icon } from './Icon';
import { Image } from './Image';
import { Link } from './Link';
import { Markdown } from './Markdown';
import { Menu } from './Menu';
import { Number } from './Number';
import { Portal } from './Portal';
import { Stepper } from './Stepper';
import { Time} from './Time';
import { Timeline} from './Timeline';
import { Toast } from './Toast';

export const UI = {
    Accordion,
    Button,
    Card,
    Date,
    Dialog,
    Form,
    Fraction,
    Icon,
    Image,
    Link,
    Markdown,
    Menu,
    Number,
    Portal,
    Stepper,
    Time,
    Timeline,
    Toast,
};
